var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rabbey-table-3',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"table",attrs:{"columns":_vm.columns,"data":_vm.items,"actions":_vm.actions,"page_Size":500,"page-sizes":[500, 1000]},on:{"rtable-push-action":_vm.handlerAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }